import React, { useEffect } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Breadcrumb, Tab, Tabs } from "react-bootstrap";
import { Link } from "react-router-dom";
import bannerImage from "../../Images/student-services/program-qualification-banner.webp";
import After10th from "./After10th";
import After12th from "./After12th";
import AfterGraduation from "./AfterGraduation";
import AfterPostgraduate from "./AfterPostgraduate";

const ProgrammesByQualification = () => {
  useEffect(() => {
    const schemas = [
      {
        id: "webpage-schema",
        data: {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "@id":
            "https://isbmuniversity.edu.in/programmes-by-qualification#webpage",
          url: "https://isbmuniversity.edu.in/programmes-by-qualification",
          name: "Which Programme Should You Choose? Find by Qualification | ISBM University",
          description:
            "Not sure which academic course fits your qualifications? Filter UG, PG & Diploma programmes by your education level and find your best fit for career growth & success.",
          isPartOf: {
            "@type": "WebSite",
            "@id": "https://isbmuniversity.edu.in/#website",
            name: "ISBM University",
            url: "https://isbmuniversity.edu.in/",
          },
          inLanguage: "en-IN",
        },
      },

      {
        id: "college-or-university-schema",
        data: {
          "@context": "https://schema.org",
          "@type": "CollegeOrUniversity",
          "@id": "https://isbmuniversity.edu.in/#collegeOrUniversity",
          name: "ISBM University | Best Private University in Chhattisgarh",
          url: "https://isbmuniversity.edu.in/",
          logo: "https://isbmuniversity.edu.in/static/media/isbm-university.9ceb30717bf3ba95be6a.webp",
          image:
            "https://isbmuniversity.edu.in/static/media/isbm-university.9ceb30717bf3ba95be6a.webp",
          description:
            "ISBM University is a private university in Chhattisgarh offering UG, PG, diploma and Ph.D. programs with industry focused education and career opportunities.",
          telephone: "+91-9373199999",
          email: "info@isbmuniversity.edu.in",
          address: {
            "@type": "PostalAddress",
            streetAddress: "Nawapara (Kosmi), Block & Tehsil- Chhura",
            addressLocality: "Gariyaband",
            addressRegion: "Chhattisgarh",
            postalCode: "493996",
            addressCountry: "IN",
          },
          sameAs: [
            "https://www.facebook.com/isbmuniversity/",
            "https://www.instagram.com/isbm_university",
            "https://www.linkedin.com/school/13211303/admin/",
          ],
        },
      },

      {
        id: "local-business-schema",
        data: {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          name: "ISBM University",
          image:
            "https://isbmuniversity.edu.in/static/media/isbm-university.9ceb30717bf3ba95be6a.webp",
          "@id": "https://isbmuniversity.edu.in/#organization",
          url: "https://isbmuniversity.edu.in/",
          telephone: "+91-9373199999",
          location: [
            {
              "@type": "Place",
              name: "ISBM University - Raipur Off-Campus",
              address: {
                "@type": "PostalAddress",
                streetAddress: "Ring Road No. 1, Near Sarona Bridge, Tatibandh",
                addressLocality: "Raipur",
                addressRegion: "Chhattisgarh",
                postalCode: "492099",
                addressCountry: "IN",
              },
            },
            {
              "@type": "Place",
              name: "ISBM University - Main Campus",
              address: {
                "@type": "PostalAddress",
                streetAddress: "Nawapara (Kosmi), Block & Tehsil - Chhura",
                addressLocality: "Gariyaband",
                addressRegion: "Chhattisgarh",
                postalCode: "493996",
                addressCountry: "IN",
              },
            },
          ],
        },
      },

      {
        id: "breadcrumb-schema",
        data: {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://isbmuniversity.edu.in/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Programmes By Qualification",
              item: "https://isbmuniversity.edu.in/programmes-by-qualification",
            },
          ],
        },
      },
    ];

    const createdScripts = [];

    schemas.forEach(({ id, data }) => {
      const existingScript = document.head.querySelector(
        `script[data-schema-id="${id}"]`,
      );

      if (existingScript) {
        existingScript.remove();
      }

      const script = document.createElement("script");

      script.type = "application/ld+json";
      script.setAttribute("data-schema-id", id);
      script.textContent = JSON.stringify(data);

      document.head.appendChild(script);

      createdScripts.push(script);
    });

    return () => {
      createdScripts.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, []);
  return (
    <React.Fragment>
      <title>
        Which Programme Should You Choose? Find by Qualification | ISBM
        University
      </title>
      <meta
        name="description"
        content="Not sure which academic course fits your qualifications? Filter UG, PG & Diploma programmes by your education level and find your best fit for career growth & success."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(77, 77, 77, 0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Programmes By Qualification</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Programmes By Qualification
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50 text-center">
        <div className="container">
          <h2 className="modern-title section-title text-blue text-center">
            Programmes by Qualification – Shape Your Future with ISBM University
          </h2>
          <p>
            ISBM University offers a wide range of programs, thoughtfully
            structured according to various educational qualifications to
            support learners at every stage of their academic and professional
            journey. Whether you're a recent school graduate, a diploma holder,
            or a working professional seeking advanced specialization, ISBM
            provides tailored academic paths to match your qualification and
            career goals.
          </p>
          <p>
            Each program is designed with a strong focus on industry relevance,
            featuring specialized courses in fields like Business Management,
            Information Technology, Pharmacy, and more. Our curriculum blends
            theoretical knowledge with practical learning through real-world
            projects, case studies, and hands-on experiences.
          </p>
          <p>
            With a commitment to research, innovation, and skill development,
            ISBM University empowers students to think critically, solve
            real-world problems, and contribute meaningfully to their fields.
            Guided by experienced faculty and supported by modern facilities,
            our qualification-based programs ensure that learners are fully
            equipped for success in their chosen careers.
          </p>
        </div>
      </section>

      <section className="pb-50">
        <div className="container">
          <h2 className="modern-title section-title text-blue text-center">
            After 10th Programmes
          </h2>
          <p className="modern-subtitle text-center text-blue">
            Build a Strong Academic Foundation
          </p>
          <p className="mb-4 m-0 text-center">
            ISBM University offers a variety of diploma and certificate courses
            specifically designed for students who have completed their 10th
            standard. These programs provide early exposure to professional
            fields, equipping students with essential skills and knowledge to
            either enter the workforce or pursue higher education.
          </p>

          <Row>
            <Col>
              <ul className="qualification-program-list row">
                <After10th />
              </ul>
            </Col>
          </Row>
        </div>
      </section>

      <section className="pb-50">
        <div className="container">
          <h2 className="modern-title section-title text-blue text-center">
            After 12th Programmes
          </h2>
          <p className="modern-subtitle text-center text-blue">
            Your Gateway to Undergraduate Studies and Career Opportunities
          </p>
          <p className="mb-4 m-0 text-center">
            After completing 12th grade, students can choose from a wide range
            of undergraduate programs at ISBM University that blend theoretical
            learning with hands-on experience. Our UG programmes are designed to
            prepare students for dynamic careers in business, technology, health
            sciences, arts, and more.
          </p>

          <Row>
            <Col>
              <ul className="qualification-program-list row">
                <After12th />
              </ul>
            </Col>
          </Row>
        </div>
      </section>

      <section className="pb-50">
        <div className="container">
          <h2 className="modern-title section-title text-blue text-center">
            After Graduation Programmes
          </h2>
          <p className="modern-subtitle text-center text-blue">
            Take the Next Step in Your Professional Journey
          </p>
          <p className="mb-4 m-0 text-center">
            ISBM University’s postgraduate programmes are tailored for students
            who have completed their undergraduate studies and wish to
            specialize further or enhance their qualifications for leadership
            roles. These courses deepen subject knowledge while incorporating
            research, strategy, and industry integration.
          </p>

          <Row>
            <Col>
              <ul className="qualification-program-list row">
                <AfterGraduation />
              </ul>
            </Col>
          </Row>
        </div>
      </section>

      <section className="pb-50">
        <div className="container">
          <h2 className="modern-title section-title text-blue text-center">
            After Post-Graduation Programmes
          </h2>
          <p className="modern-subtitle text-center text-blue">
            Aim Higher with Advanced Learning and Research
          </p>
          <p className="mb-4 m-0 text-center">
            For professionals and scholars who have completed their postgraduate
            studies, ISBM University offers advanced academic programmes
            including M.Phil. and Ph.D. These research-intensive courses are
            ideal for those aiming to contribute to academia, policy-making, or
            high-level consultancy roles.
          </p>

          <Row>
            <Col>
              <ul className="qualification-program-list row">
                <AfterPostgraduate />
              </ul>
            </Col>
          </Row>
        </div>
      </section>

      {/* <section className="qualification-content ptb-50">
        <div className="container-xxl">
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="mb-5">
                <p className="qualification-description">
                  ISBM University offers a variety of focused programs designed
                  to cater to specific fields of study and professional
                  development. These programs often include specialized courses
                  in areas such as business management, information technology,
                  pharmacy and more. The curriculum is tailored to meet industry
                  demands, providing students with practical knowledge and
                  skills through hands-on experiences, case studies, and
                  projects. Additionally, ISBM emphasizes research and
                  innovation, encouraging students to engage in projects that
                  contribute to their fields. With experienced faculty and
                  state-of-the-art facilities, the University aims to prepare
                  students for successful careers in their chosen disciplines.
                  With a focus on fostering creativity and critical thinking,
                  ISBM University prepares students to thrive in their chosen
                  careers and contribute meaningfully to society.
                </p>
              </div>

              <div className="qualification-tabs-container">
                <Tabs
                  defaultActiveKey="after10th"
                  id="program-qualification-tabs"
                  className="qualification-tabs mb-4 justify-content-center"
                  fill
                >
                  <Tab
                    eventKey="after10th"
                    title={
                      <span className="qualification-tab-title">
                        <i className="ti ti-school me-2"></i>
                        After 10th Programmes
                      </span>
                    }
                  >
                    <div className="qualification-tab-content mt-4 p-4">
                      <Row>
                        <Col >
                          <ul className="qualification-program-list row">
                            <After10th />
                          </ul>
                        </Col>
                      </Row>
                    </div>
                  </Tab>

                  <Tab
                    eventKey="after12th"
                    title={
                      <span className="qualification-tab-title">
                        <i className="ti ti-certificate me-2"></i>
                        After 12th Programmes
                      </span>
                    }
                  >
                    <div className="qualification-tab-content mt-4 p-4">
                      <Row>
                       <Col >
                          <ul className="qualification-program-list row">
                            <After12th />
                          </ul>
                        </Col>
                      </Row>
                    </div>
                  </Tab>

                  <Tab
                    eventKey="afterGraduation"
                    title={
                      <span className="qualification-tab-title">
                        <i className="ti ti-user me-2"></i>
                        After Graduation Programmes
                      </span>
                    }
                  >
                    <div className="qualification-tab-content mt-4 p-4">
                      <Row>
                        <Col>
                          <ul className="qualification-program-list row">
                            <AfterGraduation />
                          </ul>
                        </Col>
                      </Row>
                    </div>
                  </Tab>

                  <Tab
                    eventKey="afterPostgraduate"
                    title={
                      <span className="qualification-tab-title">
                        <i className="ti ti-user-plus me-2"></i>
                        After Post-Graduation Programmes
                      </span>
                    }
                  >
                    <div className="qualification-tab-content mt-4 p-4">
                      <Row>
                        <Col >
                          <ul className="qualification-program-list row">
                            <AfterPostgraduate />
                          </ul>
                        </Col>
                      </Row>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </Col>
          </Row>
        </div>
      </section> */}

      <Footer />
    </React.Fragment>
  );
};

export default ProgrammesByQualification;
